import React from "react";
import { useRef, useEffect } from "react";
import useAppContext from "../../context/Context";
import PaymentLinks from "../../assets/icons/PaymentLinks.svg";
import Conciliation from "../../assets/icons/Conciliation.svg";
import QuickTransfer from "../../assets/icons/QuickTransfer.svg";
import Returns from "../../assets/icons/Returns.svg";
import BusinessTransfer from "../../assets/icons/BusinessTransferPrice.svg";
import SubscriptionPrice from "../../assets/icons/SuscriptionPrice.svg";

import { BrandList } from "../BrandList/BrandList";

import { Layout } from "../Layout/Layout";
import TablePrivilege from "./componentes/DetailPrivilegeTable/DetailPrivilegeTable";
import "./TabPrices.scss";
import { PlanPrivilege } from "./componentes/PlanPrivilege/PlanPrivilege";

const TabPrices = () => {
  const { activeCountry } = useAppContext();
  const { getImages } = useAppContext();
  const tableRef = useRef(null);

  useEffect(() => {
    const sectionId = new URLSearchParams(window.location.search).get(
      "sectionId"
    );

    const sectionEl = document.getElementById(sectionId);

    if (sectionEl) {
      const { top } = sectionEl.getBoundingClientRect();
      window.scrollTo({ top, behavior: "instant" });
    }
  }, []);

  const handleRedirect = () => {
    tableRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Layout title="Tarifas y planes">
      <div className="body">
        <div className="homePrices column">
          <div className="containerTextHome">
            <h1 className="titleHomePrices">Tenemos el plan perfecto</h1>
            <p className="subtitleHomePrices">
              La suite de herramientas de pago “cardless” más completa
            </p>
          </div>

          <div className="containerItemsPrices">
            <div className="itemPricesProduct">
              <div className="servicesPrices">
                <img
                  src={QuickTransfer}
                  alt="quickTransfer"
                  className="imgService"
                />
                <div className="titleServices">
                  <h3
                    className={
                      activeCountry === "cl"
                        ? "titleServiceItem"
                        : "titleServiceItemMX"
                    }
                  >
                    Quick Transfer
                  </h3>

                  <p className="descriptionServices">
                    Cobra sin tarjeta en tu comercio en línea con la mejor
                    experiencia del mercado.
                  </p>
                </div>
              </div>

              {activeCountry === "cl" ? (
                <div className="servicesPrices">
                  <img src={PaymentLinks} alt="" className="imgService" />
                  <div className="titleServices">
                    <h3 className="titleServiceItem">Payment Links</h3>
                    <p className="descriptionServices">
                      Envía ligas de pago o cobra con QR, para pagos
                      presenciales y a distancia.{" "}
                    </p>
                  </div>
                </div>
              ) : (
                <div className="servicesPrices">
                  <img src={Conciliation} alt="" className="imgService" />
                  <div className="titleServices">
                    <h3 className="titleServiceItemMX">
                      Conciliación Automática
                    </h3>
                    <p className="descriptionServices right">
                      Revisa en tiempo real el estado de tus movimientos. Sin
                      incertidumbre.
                    </p>
                  </div>
                </div>
              )}
            </div>
            {activeCountry === "mx" ? (
              <div className="itemPricesProduct">
                <div className="servicesPrices">
                  <img src={PaymentLinks} alt="" className="imgService" />
                  <div className="titleServices">
                    <h3 className="titleServiceItemMX">Payment Links</h3>
                    <p className="descriptionServices">
                      Envía ligas de pago o cobra con QR, para pagos
                      presenciales y a distancia.
                    </p>
                  </div>
                </div>
                <div className="servicesPrices">
                  <img src={Returns} alt="" className="imgService" />
                  <div className="titleServices">
                    <h3 className="titleServiceItemMX">Payouts</h3>
                    <p className="descriptionServices">
                      Automatiza devoluciones, cashbacks y cualquier otro pago
                      de salida en tu negocio.
                    </p>
                  </div>
                </div>
              </div>
            ) : (
              <div className="itemPricesProduct">
                <div className="servicesPrices">
                  <img src={SubscriptionPrice} alt="" className="imgService" />
                  <div className="titleServices">
                    <h3 className="titleServiceItemMX">Débito Directo</h3>
                    <p className="descriptionServices">
                      Recibe pagos recurrentes sin necesidad de tarjetas de
                      crédito o débito.
                    </p>
                  </div>
                </div>
                <div className="servicesPrices">
                  <img src={BusinessTransfer} alt="" className="imgService" />
                  <div className="titleServices">
                    <h3 className="titleServiceItemMX">Business Transfer</h3>
                    <p className="descriptionServices">
                      Experiencia de primer nivel, recibe pagos de empresas en
                      tu negocio de forma sencilla.
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <PlanPrivilege handleClick={handleRedirect} />

        <BrandList
          brandsGroup={{
            cl: [
              getImages["brand_005"],
              getImages["brand_001_cl"],
              getImages["brand_002_cl"],
              getImages["brand_003_cl"],
              getImages["brand_002"],
              getImages["brand_006_cl"],
            ],
            es: [
              getImages["brand_001"],
              getImages["brand_003"],
              getImages["brand_004"],
            ],
            mx: [
              getImages["brand_001_mx"],
              getImages["brand_002_mx"],
              getImages["brand_003_mx"],
              getImages["brand_004_mx"],
              getImages["brand_005_mx"],
              getImages["brand_006_mx"],
              getImages["brand_007_mx"],
            ],
          }}
        />
        <div ref={tableRef} id="tableRef">
          <TablePrivilege activeCountry={activeCountry} />
        </div>

        {/* <PrivilegeDetailTemplate
          backgroundImageCard={DoubleCircle}
          imageSrc={eATM}
          product="eATM | Retiro de efectivo"
          title="Ofrece a tus clientes la posibilidad de retirar efectivo con su celular"
          details={[
            "Atrae nuevos clientes. Ofrece un nuevo servicio y genera más ventas.",
            "Optimiza tus ingresos. Gana dinero por cada retiro de efectivo.",
            "Protege tu caja. Controla tu flujo de efectivo de manera más segura.",
          ]}
        />

        <PrivilegeDetailTemplate
          backgroundImageCard={PinkCircle}
          imageSrc={BusinessTransferATM}
          product="Transferencias Business+"
          title="La solución para pagos entre empresas, proveedores, servicios básicos y nóminas."
          details={[
            "Reduce el tiempo pagando a tus socios. Un proceso simplificado para enviar tus pagos masivos",
            "Sin incertidumbre. El pago es entregado y verificado en línea",
            "Notificación personalizada. Avisa a tus aprobadores para que el pago se curse",
          ]}
          factured={1}
        /> */}
      </div>
    </Layout>
  );
};

export default TabPrices;
